import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
